import React from "react";
import geolocator from "geolocator";
import geoLocatorOptions from "./geoLocatorOptions";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import loc from "i18next";
import Button from "react-bootstrap/lib/Button";
import Constants, { type ConstantsEnum } from "data/constants";
import { type Location } from "data/types";
import { ReactComponent as TargetIcon } from "./target.svg";

type Props = {
    /** callback when location received
     * @param {Location} location new location object
     */
    onSetLocation: (location: Location) => void,
    /** CSS class to apply to button */
    className?: string,
    /** fallback to IP if Geolocation fails or rejected */
    fallbackToIP: boolean,
};

type State = {
    status: ConstantsEnum,
};

class LocatorButton extends React.PureComponent<Props, State> {
    state = {
        status: Constants.OK,
    };
    static defaultProps = {
        fallbackToIP: true,
    };

    /** Locate location by GPS */
    locate = () =>
        this.setState({ status: Constants.LOADING }, () =>
            geolocator.locate(
                geoLocatorOptions({ fallbackToIP: this.props.fallbackToIP }),
                (err, location) => {
                    if (err) {
                        /* istanbul ignore next */
                        if (err.message != null) alert(err.message);
                        console.warn(err);
                        this.setState({ status: Constants.ERROR });
                    } else {
                        this.setState({ status: Constants.OK });
                        // console.log(location);
                        this.props.onSetLocation(location.coords);
                    }
                }
            )
        );

    _buttonStatus = () => {
        switch (this.state.status) {
            case Constants.LOADING:
                return <FontAwesome name="spinner" pulse fixedWidth />;

            case Constants.OK:
                return <TargetIcon />;

            default:
                return (
                    <FontAwesome
                        name="minus-circle"
                        ariaLabel="Retrieve location"
                        fixedWidth
                    />
                );
        }
    };

    render = () => (
        <Button
            className={this.props.className}
            disabled={this.state.status === Constants.LOADING}
            title={loc.t("common:location.setCurrent")}
            onClick={this.locate}
        >
            {this._buttonStatus()}
        </Button>
    );
}

export default LocatorButton;
